import * as React from 'react';
import { Svg } from '../svg';

function SvgResendPasswordLogo({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path fill="url(#resend-password-logo_svg__pattern0)" d="M0 0h80v80H0z" />
      <defs>
        <pattern
          id="resend-password-logo_svg__pattern0"
          patternContentUnits="objectBoundingBox"
          width={1}
          height={1}
        >
          <use
            xlinkHref="#resend-password-logo_svg__image0"
            transform="scale(.0125)"
          />
        </pattern>
        <image
          id="resend-password-logo_svg__image0"
          width={80}
          height={80}
          xlinkHref="data:image/png;base64,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"
        />
      </defs>
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgResendPasswordLogo);
export default ForwardRef;
